import { FileSpreadsheet } from "lucide-react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

const EMPTY_SHEET_DESCRIPTION = "There are no cells to show for this sheet.";

interface EmptySheetStateProps {
  title: string;
  description?: string;
  isFramed?: boolean;
  fillHeight?: boolean;
}

export const EmptySheetState = ({
  title,
  description,
  isFramed = true,
  fillHeight = false,
}: EmptySheetStateProps) => (
  <Stack
    fullWidth
    align="center"
    justify="center"
    className={cn({
      "rounded-lg border border-dashed border-stroke-tertiary bg-surface-primary p-8 text-center":
        isFramed,
      "min-h-[360px]": isFramed && !fillHeight,
      "h-full": fillHeight || !isFramed,
      "p-8 text-center": !isFramed,
    })}
    gap="sm"
  >
    <FileSpreadsheet className="h-8 w-8 text-tertiary-text" />
    <Typography variant={isFramed ? "subtitleW2" : "bodyW2"}>
      {title}
    </Typography>
    {/* A description shows wherever it is given. Framed states keep their default
        line; unframed ones used to drop the prop on the floor, so callers were
        passing copy that never rendered. */}
    {(description ?? (isFramed ? EMPTY_SHEET_DESCRIPTION : null)) && (
      <Typography variant="bodyW2" textColor="secondary">
        {description ?? EMPTY_SHEET_DESCRIPTION}
      </Typography>
    )}
  </Stack>
);
